import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { Button } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { MenuButton, Permitted } from 'components'
import { DeleteInventoryModal } from './components'

import helpers from 'helpers'

import { routes } from 'Routes'
import permissions from 'constants/permissions'

const AssetInventoryTable = ({
  isLoading,
  setLoading,
  refresh,
  assetInventories = [],
  ...rest
}) => {
  const [openModal, setOpenModal] = useState(false)
  const [selectedAssetInventoryId, setSelectedAssetInventoryId] = useState(null)

  const { dates } = helpers.formatters

  const history = useHistory()

  const handleRedirectToDetails = (assetInventoryId) => {
    history.push(reverse(routes.assetInventory.show, { assetInventoryId }))
  }

  const handleRedirectToEdit = (assetInventoryId) => {
    history.push(reverse(routes.assetInventory.edit, { assetInventoryId }))
  }

  const handleOpenModal = (assetInventoryId) => {
    setSelectedAssetInventoryId(assetInventoryId)
    setOpenModal((prevState) => !prevState)
  }

  return (
    <Table
      emptyMessage="Nenhum inventário de ativos foi encontrado."
      isLoading={isLoading}
      {...rest}
    >
      <TableHead>
        <TableRow>
          <TableCell width="5%">ID</TableCell>
          <TableCell width="35%">Nome</TableCell>
          <TableCell width="35%">Categoria</TableCell>
          <TableCell align="center" width="10%">
            Criado em:
          </TableCell>
          <TableCell align="center" width="10%">
            Atualizado em:
          </TableCell>
          <TableCell align="center" width="5%">
            Ações
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {assetInventories?.map((assetInventory, index) => (
          <TableRow key={index}>
            <TableCell>{assetInventory?.id}</TableCell>
            <TableCell>{assetInventory?.name}</TableCell>
            <TableCell>
              {assetInventory?.assetInventoryCategory?.name || 'Não definida'}
            </TableCell>
            <TableCell align="center">
              {dates.ptBrFormatDateTime(assetInventory?.createdAt)}
            </TableCell>
            <TableCell align="center">
              {dates.ptBrFormatDateTime(assetInventory?.updatedAt)}
            </TableCell>
            <TableCell align="center" size="small">
              <MenuButton>
                <Button
                  color="secondary"
                  fullWidth
                  size="small"
                  onClick={() => handleRedirectToDetails(assetInventory?.id)}
                >
                  Ver detalhes
                </Button>
                <Permitted tag={permissions.ASSET_INVENTORY.MANAGE}>
                  <Button
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => handleRedirectToEdit(assetInventory?.id)}
                  >
                    Editar
                  </Button>
                  <Button
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => handleOpenModal(assetInventory?.id)}
                  >
                    Excluir
                  </Button>
                </Permitted>
              </MenuButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      {openModal && (
        <DeleteInventoryModal
          open={openModal}
          setOpen={setOpenModal}
          setLoading={setLoading}
          refresh={refresh}
          assetInventoryId={selectedAssetInventoryId}
        />
      )}
    </Table>
  )
}

export default AssetInventoryTable
